<ng-container *ngIf="windowWidth.innerWidth > 575">
  <mat-card
    ><bms-common-stepper-vertical
      [stepperData]="stepperData"
      (onStepperClick)="onStepChange($event)"
    >
    </bms-common-stepper-vertical
  ></mat-card>
</ng-container>
<ng-container *ngIf="windowWidth.innerWidth <= 575">
  <mat-card
    ><bms-common-stepper-horizontal
      [stepperData]="stepperData"
      (onStepperClick)="onStepChange($event)"
    >
    </bms-common-stepper-horizontal
  ></mat-card>
</ng-container>
